import i18n from "i18next";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import type { SubConfigurationImportAction } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/PartConfiguratorTreeStatefulView.tsx";
import { CustomerOfferLineSubConfigurationImportView } from "src/components/views/erp/configurator/configuratorForm/impl/CustomerOfferLineSubConfigurationImportView.tsx";
import { getPartConfiguratorAgentContextData } from "src/components/views/erp/configurator/configuratorForm/utils/partConfiguratorTypeUtils.ts";

export function useCustomerOfferLineSubConfigurationImportAction({
	customerOfferId,
	currentCustomerOfferLineId,
}: {
	customerOfferId: number;
	currentCustomerOfferLineId?: number;
}): SubConfigurationImportAction {
	const { openDialog } = useGenericDialog();
	const title = i18n.t("import_from_another_offer_line");

	return {
		title: title,
		onClick: async ({ targetParent, importSubConfigurations }) => {
			openDialog(({ closeDialog }) => ({
				title: title,
				size: "xl",
				content: (
					<CustomerOfferLineSubConfigurationImportView
						customerOfferId={customerOfferId}
						currentCustomerOfferLineId={currentCustomerOfferLineId}
						targetParent={targetParent}
						closeDialog={closeDialog}
						onSubmit={async (assignments) => {
							await closeDialog();
							await importSubConfigurations(assignments);
						}}
					/>
				),
				agentContext: {
					key: defineAgentUiContextKey("erp.configurator.importSubConfigurationFromOfferLine.dialog"),
					title: title,
					pathSegments: [targetParent.label],
					data: {
						...getPartConfiguratorAgentContextData(targetParent.configuratorType),
						treeItemKey: targetParent.key,
						customerOfferId: customerOfferId,
					},
				},
			}));
		},
	};
}
